import { Image, Text } from "@/atoms";
import { cn } from "@/lib/utils";

type GiftCardPreviewImageProps = {
  amount?: string;
  backgroundImage: string;
  size?: "icon" | "xsmall" | "small" | "medium" | "large";
  platformLogoUrl?: string | null;
};

export const GiftCardPreviewImage = ({
  amount,
  backgroundImage,
  size = "medium",
  platformLogoUrl,
}: GiftCardPreviewImageProps): React.ReactElement => {
  return (
    <div className="GiftCardPreviewImage relative flex h-full w-full items-center justify-center overflow-hidden rounded-lg">
      <Image
        alt="Gift Card background"
        className={cn(
          "aspect-16/9 absolute inset-0 z-0",
          size == "medium" && "min-h-[92px]"
        )}
        src={backgroundImage}
        width={170}
        height={110}
      />

      {amount && (
        <div
          className={cn(
            "absolute bottom-3 left-3 z-10 flex items-start justify-start",
            size === "icon" && "gap-1",
            (size === "xsmall" || size === "icon") && "bottom-1 left-1"
          )}
        >
          <Text
            className={cn("relative top-1 font-bold text-white")}
            text="$"
            variant={size === "icon" || size === "xsmall" ? "body3" : "body1"}
          />
          <Text
            className={cn("relative top-1 font-bold text-white")}
            text={amount}
            variant={size === "icon" || size === "xsmall" ? "body1" : "h1"}
          />
        </div>
      )}

      {platformLogoUrl && (
        <div className="absolute bottom-3 right-3 z-10 h-10 w-10 overflow-hidden rounded-full bg-white p-1">
          <Image
            alt="Platform logo"
            className="h-full w-full object-contain"
            src={platformLogoUrl}
            width={32}
            height={32}
          />
        </div>
      )}
    </div>
  );
};
